import { render, staticRenderFns } from "./NicheEdit_Desktop.vue?vue&type=template&id=b05cce58&scoped=true&"
import script from "./NicheEdit_Desktop.vue?vue&type=script&lang=js&"
export * from "./NicheEdit_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./NicheEdit_Desktop.vue?vue&type=style&index=0&id=b05cce58&prod&lang=css&"
import style1 from "./NicheEdit_Desktop.vue?vue&type=style&index=1&id=b05cce58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05cce58",
  null
  
)

export default component.exports